/* eslint-disable max-lines */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable vars-on-top */
/* eslint-disable max-statements*/
/* eslint-disable no-useless-concat*/
/* eslint-disable max-len */

ACC.interstitialPopUp = {
  recomIntertitialView: function(product) {
    $.ajax({
      type: 'POST',
      url: ACC.config.encodedContextPath + '/asyncproduct/getRecommendedProducts',
      dataType: 'json',
      data: {
        codes: product
      },
      success: function(result) {
        $('.ph-spinnerinterstitial').addClass('hidden');
        $('.ph-recommended-products-desk li').remove();

        if ($(window).width() > 600) {
          ACC.interstitialPopUp.recomIntertitialDeskView(result);
          $.colorbox.resize();
          $('.ph-interstitial-popup-products-added-parent-mob').addClass('hidden');
        } else {
          $('.ph-recommended-productsPDP').removeClass('hidden');
          ACC.interstitialPopUp.recomIntertitialMobView(result);
          $.colorbox.resize();
          $('.ph-interstitial-margin-checkout-btn').addClass('hidden');
          $('.ph-interstitial-popup-products-added-parent-desk').addClass('hidden');
        }
      }

    });
  },
  recommendedAtpcall: function(prodCodes) {
    var backordertoggle = $('#ph-backorderRecom').val(),
        maxval = '-maxQty';

    $.ajax({
      type: 'POST',
      url: ACC.config.encodedContextPath + '/asyncproduct/getatpdata',
      dataType: 'json',
      data: {
        code: prodCodes
      },
      success: function(atpResult) {
        var commonClass = 'cboxLoadedContent .ph-ra_additional-products-desk',
            prodCd = ' #prodcode-',
            $liClass = $('#' + commonClass + prodCd + atpResult.code),
            $passClass = $('#' + commonClass + ' #ph-qty-' + atpResult.code);

        if (atpResult) {
          if ($(window).width() < 600) {
            var commonClassMob = 'cboxLoadedContent .ph-ra_additional-productsMob';

            $liClass = $('#' + commonClassMob + prodCd + atpResult.code);
            $passClass = $('#' + commonClassMob + ' #ph-qty-' + atpResult.code);
          }

          if (atpResult.atpData.availabilityCode === 'red') {
            $liClass.remove();
            $.colorbox.resize();
            ACC.recommendedadditionalproducts.rvcardsCarousel();

            var loadCont = 'LoadedContent',
                link = '_link',
                $totalList = $('#cbox' + loadCont + ' .ph-ra_additional-productsMob .ph-prod-mobView');

            if ($totalList.length > 2) {
              $totalList.removeClass('hidden');
              $totalList.slice(2, $totalList.length).addClass('hidden');
            } else {
              $('#cbox' + loadCont + ' .ph-seemore' + link).hide();
            }

            $.colorbox.resize();
          }

          if (atpResult.atpData.availabilityCode === 'green' && backordertoggle === 'true') {
            $passClass.attr('data' + maxval, atpResult.atpData.maxStockQty);
          }

          if (atpResult.atpData.availabilityCode === 'orange' && backordertoggle === 'true') {
            $passClass.attr('data-maxQty', atpResult.atpData.lowStockQty);
          }
        }
      }
    });
  },
  showmoreLink: function(result) {
    var cont = 'Content';

    if (result.length > 2) {
      $('#cboxLoaded' + cont + ' .ph-prod-mobView').slice(1, result.length).addClass('hidden');
    } else {
      $('#cboxLoaded' + cont + ' .ph-seemore_link').hide();
    }
  },
  recomIntertitialMobView: function(result) {
    var indx = 0,
        codes = [],
        rvids = '',
        promoribben = 'promotionribbon',
        promRibbon = $('.ph-' + promoribben).val(),
        newIndicator = $('.ph-newindicator').val(),
        backOrder = '-backorderRecom',
        backordertoggle = $('#ph' + backOrder).val(),
        currentIndexJsMob = 0,
        mobileId = 'additional-productsMob',
        preferredtext = $('#ph-preferredtext').val(),
        preferredid = $('#ph-preferredid').val(),
        unitpriceaddVal = $('#ph-unitpriceadd').val(),
        arrayofdchain = 0,
        dhcainJsIndicator = '';

    arrayofdchain = ACC.decisionPageInfiniteLoader.checkdchainInList();

    $('.ph-ra_' + mobileId).html('');

    if (Array.isArray(result) && result.length > 0) {
      for (indx; indx < result.length; indx = indx + 1) {
        var updateProdCtvMob = '',
            updateProdDisplayNameMob = '',
            recommendedprodListnameMob = $('.ph-recommendedList').val(),
            preferredCode = result[indx].product.code,
            emptytxt = $('.ph-notAvailTxt').val();

        if (preferredid === 'PRODUCT_EAN') {
          preferredCode = result[indx].product.sapEan;
        }

        if (preferredCode.length === 0) {
          preferredCode = emptytxt;
        }

        updateProdCtvMob = ACC.interstitialPopUp.recomIntertitialUpdateProdCtvMob(result[indx].product.ctv, 'ctv');
        updateProdDisplayNameMob = ACC.interstitialPopUp.recomIntertitialUpdateProdCtvMob(result[indx].product.displayName, 'displayName');

        if (backordertoggle === 'true') {
          ACC.interstitialPopUp.recommendedAtpcall(result[indx].product.code);
        }

        if ($('.ph-dchain_Indicator').length > 0) {
          dhcainJsIndicator = $('.ph-dchain_Indicator').val();
        }

        ACC.interstitialPopUp.showmoreLink(result);

        currentIndexJsMob = indx + 1;
        $('.ph-ra_' + mobileId).append('<li class="ph-ra_productcard ph-recom_' + result[indx].product.code + '" ph-prod-mobView" id="prodcode-' +
                    result[indx].product.code + '" data-prodid = "' + result[indx].product.code + '" data-ctn = "' + result[indx].product.ctv +
                    '" data-list-name = "' + recommendedprodListnameMob + '" data-list-position = "' + currentIndexJsMob + '"data-track-productcard-visibility>' +
                    '<div class="ph-card-itemMob" id= ' + rvids + '>' +
                    '<a  class="ph-product-url" href = ' + ACC.config.encodedContextPath + result[indx].product.url + '>' +
                    '<div class="ph-pro-outer-wrapMob">' +
                    '<div class="ph-topwrap">' +
                    '<div class="ph-col-4 ph-card-image-wrapperMob">' +
                    '<div class="p-promotion-ribbon p-promotion-ribbon--new ph-new-indicator ph-new-indicatorMob">' +
                    '<div class="p-promotion-ribbon-inner">' + newIndicator +
                    '</div></div>' + dhcainJsIndicator +
                    '<img class="ph-product-image ph-card-imageMob" src="' + result[indx].product.imageURL + '">' +
                    '<div class="ph-discount-ribbon ph-discount-ribbonMob hidden-xs ph-product-card__ribbon">' +
                    '<div class="ph-discount-ribbon__text ph-body-copy-03 ph-bold ph-bg__solid-wordmark-blue">' + promRibbon +
                    '</div></div></div>' +
                    '<div class="ph-card-product-detailsMob">' +
                    '<p class="ph-product-number">' +
                    '<span class="ph-product-skuMob">' + preferredtext + ': ' + preferredCode +
                            '</span>' + updateProdCtvMob +
                    '</p>' + updateProdDisplayNameMob +
                    '</div></a>' + '<div class="ph-interstitial-btmCont"><div class="ph-sg-price-wraprMob">' + unitpriceaddVal +
                    '<p class="ph-product-priceMob" id= ' + result[indx].product.code + '>' +
                    '<span class="ph-ra_list-price">' +
                    '</span>' +
                    '<span class="ph-strike-price">' +
                    '</span>' +
                    '</p>' +
                    '</div>' +
                    '<div class="ph-decisionpage__bottomcontent ph-interstitial-bottomcontent-padding"><div class="ph-align__bottom">' +
                    '<div class="ph-cartblock"><div class="ph-cartcontent">' +
                    '<button ' + 'value= "' + result[indx].product.code + '" id = "ph-select-' + result[indx].product.code +
                    '" class="ph-addToCartButtonInterstitial" type="button">' +
                    '<div class="ph-cart' + '-interstitial">' +
                    '<span class="icon ph-icon-check-white ph-float-right"></span>' +
                    '</div></but' + 'ton>' +
                    '<button ' + 'value= "' + result[indx].product.code + '" class="ph-addToCartButtonInterstitialToggle hidden" type="button">' +
                    '<div class="ph-cart' + '-interstitial">' +
                    '<span class="icon ph-icon-check-white-toggle ph-float-right"></span>' +
                    '</div></but' + 'ton>' +
                    '<input size="1" name="qty" id = "ph-qty-' + result[indx].product.code +
                    '" onkeypress="return isNumberKey(event)" data-maxQty = " " maxlength="11" type="text" value="1" class=" ph-pdpquantity ph-float-right">' +
                    '<div class="ph-popupRec ph-productQtytoolDesk hidden" >' +
                    '<div class="ph-backordermaxcountdecFly">' + $('#ph-stock-msg').val() + '</div></div' +
                    '</div></div></div></div></div>' +
                    '</div></div></li>');

        codes.push(result[indx].product.code);

        if ($.inArray(result[indx].product.dchainValue, arrayofdchain) !== -1) {
          $('#prodcode-' + result[indx].product.code).find('.ph-dchainvalue' + result[indx].product.dchainValue).removeClass('ph-d-none');
        }
      }

      ACC.recommendedadditionalproducts.rvgetPrice(codes);
    }
  },
  /* eslint-disable complexity*/
  recomIntertitialDeskView: function(result) {
    var indx = 0,
        codes = [],
        rvids = '',
        promoribben = 'promotionribbon',
        promRibbon = $('.ph-' + promoribben).val(),
        newIndicator = $('.ph-newindicator').val(),
        backordertoggle = $('#ph-backorderRecom').val(),
        stockMsg = 'stock-msg',
        currentIndexJs = 0,
        preferredtext = $('#ph-preferredtext').val(),
        preferredid = $('#ph-preferredid').val(),
        txtProdDesk = 'products-desk',
        unitpriceaddVal = $('#ph-unitpriceadd').val(),
        arrayofdchain = 0,
        dhcainJsIndicator = '';

    arrayofdchain = ACC.decisionPageInfiniteLoader.checkdchainInList();

    $('.ph-recommended-' + txtProdDesk).removeClass('hidden');
    $('.ph-recommended-productsPDP').addClass('hidden');

    if (Array.isArray(result) && result.length > 0) {
      $('.ph-interstitial-no-products').addClass('hidden');
      $('.ph-interstitial-arrow').removeClass('hidden');

      for (indx; indx < result.length; indx = indx + 1) {
        var prodUnits = '',
            unitsText = '',
            updateProdCtv = '',
            updateProdDisplayName = '',
            recommendedprodListname = $('.ph-recommendedList').val(),
            deskId = '-products-desk',
            preferredCode = result[indx].product.code,
            emptytxt = $('.ph-notAvailTxt').val();

        if (preferredid === 'PRODUCT_EAN') {
          preferredCode = result[indx].product.sapEan;
        }

        if (preferredCode.length === 0) {
          preferredCode = emptytxt;
        }

        updateProdCtv = ACC.interstitialPopUp.recomIntertitialUpdateProdCtv(result[indx].product.ctv, 'ctv');
        updateProdDisplayName = ACC.interstitialPopUp.recomIntertitialUpdateProdCtv(result[indx].product.displayName, 'displayName');

        if (result[indx].product.numberContentUnits) {
          prodUnits = result[indx].product.numberContentUnits;
          unitsText = $('.ph-produnits').val();
        }

        if ($('.ph-dchain_Indicator').length > 0) {
          dhcainJsIndicator = $('.ph-dchain_Indicator').val();
        }

        currentIndexJs = indx + 1;
        $('.ph-ra_additional' + deskId).append('<li  class="ph-ra_productcard ph-recom_' + result[indx].product.code + '" id="prodcode-' +
              result[indx].product.code + '" data-prodid = "' + result[indx].product.code + '" data-ctn = "' + result[indx].product.ctv +
              '" data-list-name = "' + recommendedprodListname + '" data-list-position = "' + currentIndexJs + '"data-track-productcard-visibility>' +
              '<div class="ph-card-item ph-card-item-padding" id= ' + rvids + '>' +
              '<a  class="ph-product-url" href = ' + ACC.config.encodedContextPath + result[indx].product.url + '>' +
              '<div class="ph-pro-outer-wrap">' +
              '<div class="ph-topwrap">' +
              '<div class="ph-card-image-wrapper">' +
              '<img class="ph-product-image ph-card-image" src="' + result[indx].product.imageURL + '&wid=145&hei=145&$jpglarge$">' +

              '<div class="p-promotion-ribbon p-promotion-ribbon--new ph-new-indicator ph-new-indicator-interstitial">' +
              '<div class="p-promotion-ribbon-inner">' + newIndicator +
              '</div></div>' + dhcainJsIndicator +
              '<div class="ph-discount-ribbon ph-discount-ribbon-interstitial hidden-xs ph-product-card__ribbon">' +
              '<div class="ph-discount-ribbon__text ph-body-copy-03 ph-bold ph-bg__solid-wordmark-blue">' +
              '<span>' + promRibbon + '</span>' +
              '</div></div></div>' +
              '<div class="ph-card-product-details">' +
              '<p class="ph-product-number">' +
              '<span class="ph-product-sku">' + '<span class="ph-prvalue ph-recommprod">' + preferredtext + '</span>: ' + preferredCode +
                      '</span>' + updateProdCtv +
              '</p>' + updateProdDisplayName +
              '</div></div>' +
              '</div></a>' +
              '<div class="ph-decisionpage__bottomcontent ph-interstitial-bottomcontent-padding">' + unitpriceaddVal + '<div class="ph-sg-price-wrapr ph-product-price-width">' +
              '<p class="ph-product-price" id= ' + result[indx].product.code + '>' +
              '<span class="ph-ra_list-price">' +
              '</span>' +
              '<span class="ph-strike-price">' +
              '</span>' +
              '</p></div>' +
              '<div class="ph-product-count ph-product-count-border">' +
                '<span class="ph-pkgqty">' + prodUnits + ' ' + '</span>' +
                  '<span class="ph-pkgunit">' + unitsText + '</span></div><div class="ph-align__bottom">' +
              '<div class="ph-cartblock"><div class="ph-cartcontent">' +
              '<button id = "ph-select-' + result[indx].product.code + '" value= "' + result[indx].product.code + '" class="ph-addToCartButtonInterstitial" type="button">' +
              '<div class="ph-cart-interstitial">' +
                  '<span class="icon ph-icon-check-white ph-float-right"></span>' +
              '</div></button>' +
              '<button value= "' + result[indx].product.code + '" class="ph-addToCartButtonInterstitialToggle hidden" type="button">' +
              '<div class="ph-cart-interstitial">' +
                  '<span class="icon ph-icon-check-white-toggle ph-float-right"></span>' +
              '</div></button>' +
              '<input size="1" name="qty" id = "ph-qty-' + result[indx].product.code +
              '" onkeypress="return isNumberKey(event)" data-maxQty = " " maxlength="11" type="text" value="1" class=" ph-pdpquantity ph-float-right">' +
              '<div class="ph-popupRec ph-productQtytoolDesk hidden" >' +
              '<div class="ph-backordermaxcountdecFly">' + $('#ph-' + stockMsg).val() + '</div></div' +
              '</div></div></div></div></div>' +
              '</div></div></li>');

        codes.push(result[indx].product.code);

        if (backordertoggle === 'true') {
          ACC.interstitialPopUp.recommendedAtpcall(result[indx].product.code);
        }

        if ($.inArray(result[indx].product.dchainValue, arrayofdchain) !== -1) {
          $('#prodcode-' + result[indx].product.code).find('.ph-dchainvalue' + result[indx].product.dchainValue).removeClass('ph-d-none');
        }
      }

      ACC.recommendedadditionalproducts.rvgetPrice(codes);
    } else {
      $('.ph-interstitial-no-products').removeClass('hidden');
    }

    if ($('.ph-recentlyviewed-products li').length > 0) {
      $.colorbox.resize();

      if ($(window).width() > 600) {
        ACC.recommendedadditionalproducts.rvcardsCarousel();
      } else {
        var rvcardWidth = $('#cboxLoadedContent .ph-recentlyviewed-products__jcarousel').innerWidth() / 2;

        $('.ph-recentlyviewed-products').find('li').css('width', rvcardWidth + 'px');
      }
    }

    $.colorbox.resize();
  },
  /* eslint-enable complexity*/
  recomIntertitialPriceContent: function(rowPrice, isPromotionEnabled, rvitemCode, discVal) {
    var cboxCheck = '',
        promRibbon = $('.ph-promotionribbon').val(),
        recomText = '.ph-recom_',
        loadedContent = 'LoadedContent';

    if ($('#cbox' + loadedContent).length > 0) {
      cboxCheck = '#cboxLoadedContent';
      recomText = ' #prodcode-';
    }

    if (rowPrice.priceType === 'FROM' && isPromotionEnabled > 0) {
      $(cboxCheck + ' #' + rvitemCode).find('.ph-strike-price').show();
      $(cboxCheck + ' #' + rvitemCode).find('.ph-strike-price').html(rowPrice.formattedValue + ' ');
      $(cboxCheck + recomText + rvitemCode).find('.ph-discount-ribbon').show();

      var discRibbon = $(cboxCheck + recomText + rvitemCode).find('.ph-discount-ribbon__text');

      discRibbon.html(promRibbon.replace('0', discVal));
    } else if (rowPrice.priceType === 'BUY' && rowPrice.pricingConditionCode !== 'YLRR') {
      $(cboxCheck + ' #' + rvitemCode).find('.ph-ra_list-price').html(rowPrice.formattedValue);
    }
  },

  recomIntertitialUpdateProdCtv: function(elementCheck, elementType) {
    var productContent = '';

    if (elementCheck !== null && elementType === 'ctv') {
      var ctvtext = $('.ph-pop-ctv').val();

      productContent = '<div class="ph-ra_product-ctv">' +
        '<span class="ph-product-ctvtext ph-prvalue ph-recommprod">' + ctvtext +
        '</span>' +
        '<span class="ph-ra_product-ctv">' + ' ' + ':' + ' ' + elementCheck +
        '</span></div>';
    }

    if (elementCheck !== null && elementType === 'displayName') {
      productContent = '<span class="ph-product-title ph-productdetails" style="-webkit-box-orient: vertical;">' + elementCheck + '</span>';
    }


    return productContent;
  },
  recomIntertitialUpdateProdCtvMob: function(elementCheck, elementType) {
    var productContent = '';

    if (elementCheck !== null && elementType === 'ctv') {
      var ctvtext = $('.ph-pop-ctv').val();

      productContent = '<div class="ph-ra_product-ctvMob">' +
      '<span class="ph-product-ctvtextMob">' + ctvtext +
      '</span>' +
      '<span class="ph-ra_product-ctvMob">' + ' ' + ':' + ' ' + elementCheck +
      '</span></div>';
    }

    if (elementCheck !== null && elementType === 'displayName') {
      productContent = '<span class="ph-product-titleMob ph-productdetails" style="-webkit-box-orient: vertical;">' + elementCheck + '</span>';
    }

    return productContent;
  },
  checkstorespecific: function(devicespec, prodVal) {
    var pricevalue = '';

    if (window.eddlContext.locale.currency === 'THB') {
      pricevalue = $('.ph-interstitial-popup-section').find('.ph-recom_' + prodVal + ' .ph-ra_list-price').text().replace(/,/g, '');
    } else {
      pricevalue = $('.ph-interstitial-popup-section').find('.ph-recom_' + prodVal + ' .ph-ra_list-price').text().replace(/,(?=[^,]*$)/, '.');
    }

    return pricevalue;
  },
  checkoutContinue: function(viewParent, uniqId, cardView) {
    var productList = [],
        productItem = '',
        products = [],
        prodcheckCount = ' .checkCountProd',
        loadedCont = 'LoadedContent ';

    $('#cbox' + loadedCont + viewParent + ' ' + cardView + prodcheckCount).each(function() {
      var prodVal = $(this).val(),
          qtyVal = $('#cbox' + loadedCont + uniqId + ' #ph-qty-' + prodVal).val(),
          priceDivMobParent = '.ph-interstitial-btmCont',
          priceDivDeskParent = '.ph-decisionpage__bottomcontent',
          prodCtv = '',
          price = '';

      productList.push(prodVal + ':' + qtyVal);

      if ($(this).parents(priceDivMobParent).length > 0) {
        price = ACC.interstitialPopUp.checkstorespecific(priceDivMobParent, prodVal);
      } else {
        price = ACC.interstitialPopUp.checkstorespecific(priceDivDeskParent, prodVal);
      }

      prodCtv = $(this).parents('.ph-ra_productcard').attr('data-ctn');

      if (prodCtv === '') {
        prodCtv = prodVal;
      }

      productItem = ACC.googleanalytics.createProductListForGa(prodCtv, qtyVal, price);
      products.push(productItem);
    });

    if ($('#cbox' + loadedCont + viewParent + ' ' + cardView + prodcheckCount).length > 0) {
      ACC.googleanalytics.gaAddtocart('Interstitial-Popup', products);
    }

    return productList;
  }
};

$(document).on('click', '.ph-seemore_link', function() {
  $('#cboxLoadedContent .ph-prod-mobView').removeClass('hidden');

  $('#cboxLoadedContent .ph-seemore_link').hide();

  $.colorbox.resize();
});

$(document).click(function(event) {
  var $popUpContainer = $('#cboxLoadedContent .ph-interstitial-popup-section');

  if (!$popUpContainer.is(event.target) && $popUpContainer.has(event.target).length === 0) {
    $('#cboxLoadedContent .ph-interstitial-close-btn').trigger('click');
  }
});
$(document).on('keyup', '#cboxLoadedContent .ph-pdpquantity', function() {
  var productQty = $(this).val(),
      qtyId = $(this).attr('id'),
      maxQty = $(this).attr('data-maxQty'),
      flyoutText = '',
      codeVal = qtyId.split('ph-qty-'),
      disableBtn = '-disable-button',
      cartInst = 'cart-interstitial',
      cboxCont = 'cboxLoadedContent',
      select = 'select-',
      selectNew = '-select',
      cboxContent = '#cboxLoadedContent',
      $backordcountVal = $('#cboxLoadedContent #prodcode-' + codeVal[1] + ' .ph-backordermaxcountdecFly');

  if (parseInt(productQty, 10) > parseInt(maxQty, 10)) {
    flyoutText = $('#ph-stock-msg').val();
    $backordcountVal.text(flyoutText.replace('0', maxQty));

    $('#cboxLoadedContent #' + qtyId).next().removeClass('hidden');
    $('#' + cboxCont + ' #ph-' + select + codeVal[1]).attr('disabled', 'disabled');
    $('#' + cboxCont + ' #ph-select-' + codeVal[1] + ' .ph-' + cartInst).addClass('ph' + disableBtn);
    $(cboxContent + ' #ph-' + select + codeVal[1] + '.ph-addToCartButtonInterstitial').css('pointer-events', 'none');
  } else {
    $('#cboxLoadedContent #' + qtyId).next().addClass('hidden');
    $('#' + cboxCont + ' #ph-select-' + codeVal[1]).attr('disabled', false);
    $(cboxContent + ' #ph' + selectNew + '-' + codeVal[1] + ' .ph-cart-interstitial').removeClass('ph' + disableBtn);
    $(cboxContent + ' #ph' + selectNew + '-' + codeVal[1] + '.ph-addToCartButtonInterstitial').css('pointer-events', 'auto');
  }
});
$(document).on('click', '.ph-interstitial-checkout-btn,.ph-interstitial-checkout-btnMob', function() {
  var productList = [],
      section = '-top-section',
      events = '-events',
      close = 'close-btn',
      pointerChk = 'pointer',
      parentId = $(this).attr('id'),
      cardView = '.ph-card-item',
      prodParent = '.ph-recommended-products-desk',
      disBtn = 'disable-button',
      btmContent = 'decisionpage__bottomcontent',
      prodUl = '.ph-ra_additional-products-desk';

  $('.ph-interstitial-loader').removeClass('hidden');
  $(this).addClass('ph-' + disBtn);
  $('.ph-cont-loader').addClass('hidden');
  $('.ph-interstitial' + section).css('pointer' + events, 'none');
  $('.ph-interstitial-' + close).css('pointer' + events, 'none');
  $('.ph-' + btmContent).css(pointerChk + '-events', 'none');
  $('.ph-cart-interstitial,.ph-interstitial-continue-btn,.ph-interstitial-continue-btnMob').attr('disabled', 'disabled').addClass('ph-' + disBtn);

  if (parentId !== 'ph-interstitial-checkout-btnDesk') {
    cardView = '.ph-card-itemMob';
    prodParent = '.ph-recommendedProducts_mobView';
    prodUl = '.ph-ra_additional-productsMob';
  }

  productList = ACC.interstitialPopUp.checkoutContinue(prodParent, prodUl, cardView);
  $('#checkoutData').val(productList.toString());
  $('#checkoutForm').submit();
});

$(document).on('click', '.ph-interstitial-continue-btn,.ph-interstitial-continue-btnMob,.ph-interstitial-close-btn', function() {
  var productList = [],
      event = 'events',
      pointer = 'pointer',
      loader = 'cont-loader',
      parentId = $(this).attr('id'),
      contCardView = '.ph-card-item',
      instChkOut = 'interstitial-checkout-btnMob',
      hideBtn = 'disable-button',
      btmCont = '__bottomcontent',
      contProdParent = '.ph-recommended-products-desk',
      contProdUl = '.ph-ra_additional-products-desk';

  if ($(window).width() < 600 && parentId !== 'ph-interstitial-continue-btnDesk') {
    contProdParent = '.ph-recommendedProducts_mobView';
    contCardView = '.ph-card-itemMob';
    contProdUl = '.ph-ra_additional-productsMob';
  }

  productList = ACC.interstitialPopUp.checkoutContinue(contProdParent, contProdUl, contCardView);

  $('.ph-interstitial-loader').addClass('hidden');
  $('.ph-' + loader).removeClass('hidden');
  $('.ph-interstitial-top-section').css('pointer-' + event, 'none');
  $('.ph-interstitial-close-btn').css('pointer-' + event, 'none');
  $('.ph-decisionpage' + btmCont).css(pointer + '-events', 'none');
  $('.ph-cart-interstitial,.ph-interstitial-checkout-btn,.ph-interstitial-checkout-btnMob').attr('disabled', 'disabled').addClass('ph-disable-button');

  if ($('.checkCountProd').is(':visible')) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/cart/add/multiple',
      data: {
        products: productList.toString()
      },
      type: 'POST',
      Datatype: 'json',
      success: function(cartResult) {
        var addToCartLayerId = '#addToCartLayer';

        $('.ph-' + loader).addClass('hidden');
        $('.ph-decisionpage' + btmCont).css(pointer + '-events', 'auto');
        $('.ph-cart-interstitial,.ph-interstitial-checkout-btn,.ph-interstitial-checkout-btnMob').attr('disabled', false).removeClass('ph-' + hideBtn);

        if (cartResult.miniCartCount) {
          $('#miniCartIcon').html('<div class="quantity-balloon"></div>');
          $('#miniCartIcon .quantity-balloon').html(cartResult.miniCartCount);
          ACC.minicart.$layer.data('needRefresh', true);
        }

        $('#header').append(cartResult.addToCartLayer);
        clearTimeout(window.sto);

        $(addToCartLayerId).fadeIn(function() {
          $.colorbox.close();

          setTimeout(function() {
            $(addToCartLayerId).fadeOut(function() {
              $('#header #addToCartLayer').remove();
            });
          }, 5000);
        });
      },
      error: function() {
        $.colorbox.close();
      }
    });
  } else {
    $('.ph-' + loader).addClass('hidden');
    $('.ph-decisionpage__bottomcontent').css(pointer + '-events', 'auto');
    $('.ph-cart-interstitial,.ph-interstitial-checkout-btn,.ph-' + instChkOut).attr('disabled', false).removeClass('ph-' + hideBtn);
    $.colorbox.close();
  }
});
/* eslint-enable max-lines */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable vars-on-top */
/* eslint-enable max-statements*/
/* eslint-enable no-useless-concat*/
/* eslint-enable max-len */


